import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Collapse,
  Form,
  Label,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";

import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import moment from "moment";
import get from "lodash/get";
import InputText from "../InputText";
import { useEffect } from "react";
import { helperFunctionForBooleanValue } from "../../utils/helperFunction";

const _ = { get };

const MemberDetailPage = ({ rowData, elements }) => {
  return (
    <React.Fragment>
      {rowData ? (
        <div className="hideSearch my-3 px-3">
          {/* <Row>
						<Col xl={3} lg={4} md={6} sm={6} className="mb-4">
							<DesignCard
								name={_.get(
									elements,
									
									
								)}
								// titleName={`${rowData.vin}`}
							/>
						</Col>
						<Col xl={3} lg={4} md={6} sm={6} className="mb-4">
							<DesignCard
								name={_.get(
									elements,
									
									
								)}
								// titleName={rowData.vehicleModelName}
							/>
						</Col>
						<Col xl={3} lg={4} md={6} sm={6} className="mb-4">
							<DesignCard
								name={_.get(
									elements,
									
								)}
								// titleName={rowData.purchaseDate}
							/>
						</Col>
						<Col xl={3} lg={4} md={6} sm={6} className="mb-4">
							<DesignCard
								name={_.get(
									elements,
									
								)}
								// titleName={rowData.registrationNo}
							/>
						</Col>
					</Row> */}

          {/* <Row>
						<Col xl={3} lg={4} md={6} sm={6} className="mb-4">
							<InputText
								labelName={_.get(
									elements,
									
								)}
								inputType={"text"}
								inputName={"email"}
								InputClass={"inputText mb-0"}
								inputPlaceholder={_.get(
									elements,
									
								)}
								customValue={email}
								customOnChange={(e) =>
									handleSetValue(e, "email")
								}
							/>
						</Col>
						<Col xl={3} lg={4} md={6} sm={6}>
							<div className="d-flex align-item-center mt-4 pt-1">
								<CustomButton
									name={_.get(
										elements,
										
									)}
									customClass={
										"btn-outline-dark bg-none btnthemeColor mt-auto"
									}
									customClick={() => handleUserSearch()}
								/>
							</div>
						</Col>
					</Row> */}
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.branchCodeElement",
                  "Branch Code"
                )}
                titleName={rowData.branchCode}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.branchNameElement",
                  "Branch name"
                )}
                titleName={rowData.branchName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.dobElement",
                  "DOB"
                )}
                titleName={moment(rowData.dob).format("YYYY")}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.membershipCategoryElement",
                  "MemberShip Category"
                )}
                titleName={rowData.membershipCategory}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.moderationStatusElement",
                  "Moderation Status"
                )}
                titleName={rowData.moderationStatus}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.vehicleModelCodeElement",
                  "Vehicle Model Code"
                )}
                titleName={rowData.vehicleModelCode}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.vehicleModelColorElement",
                  "Vehicle Model Color"
                )}
                titleName={rowData.vehicleModelColor}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.vehicleModelNameElement",
                  "Vehicle Model name"
                )}
                titleName={rowData.vehicleModelName}
              />
            </Col>

            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.consentsAllPromotionsElement",
                  "All Promotions"
                )}
                titleName={helperFunctionForBooleanValue(rowData.allpromotions)}
              />
            </Col>

            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.consentsCommunityActivitiesElement",
                  "Community Activities"
                )}
                titleName={helperFunctionForBooleanValue(
                  rowData.communityactivities
                )}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.consentsDoNotEmailElement",
                  "Email"
                )}
                titleName={helperFunctionForBooleanValue(!rowData.donotemail)}
              />
            </Col>

            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.consentsDoNotPhoneElement",
                  "Phone"
                )}
                titleName={helperFunctionForBooleanValue(!rowData.donotphone)}
              />
            </Col>

            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.consentsPromotionsNewsElement",
                  "Promotional News"
                )}
                titleName={helperFunctionForBooleanValue(
                  rowData.promotionsnews
                )}
              />
            </Col>

            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "memberListingDetailPanelElement.consentsSurveysAndResearchElement",
                  "Survey and Research"
                )}
                titleName={helperFunctionForBooleanValue(
                  rowData.surveysandresearch
                )}
              />
            </Col>
            {/* <Col
									xl={3}
									lg={4}
									md={6}
									sm={6}
									className="mb-4"
								>
									<DesignCard
										name={_.get(
											elements,
											
										)}
										// titleName={
										// 	allUser[0].contactDetails.email
										// }
									/>
								</Col>
								<Col
									xl={3}
									lg={4}
									md={6}
									sm={6}
									className="mb-4"
								>
									<DesignCard
										name={_.get(
											elements,
											
										)}
										// titleName={
										// 	allUser[0].contactDetails.mobile
										// 		.primary.number
										// }
									/>
								</Col>

								<Col
									xl={12}
									lg={12}
									md={12}
									sm={12}
									className="mb-4"
								>
									<div className="d-flex justify-content-end">
										<CustomButton
											name={_.get(
												elements,
												
											)}
											customClass={
												"btn-outline-dark bg-none btnthemeColor"
											}
											customClick={() =>
												handleToggleModel()
											}
										/>
									</div>
								</Col> */}
          </Row>
          {/* </>
					) : (
						!rowData && (
							<h5 className="text-center font-weight-bold">
								No user found
							</h5>
						)
					)} */}
        </div>
      ) : (
        <h5 className="text-center font-weight-bold">
          {_.get(
            elements,
            "memberListingDetailPanelElement.noUserFoundElement",
            "No user found"
          )}
        </h5>
      )}
    </React.Fragment>
  );
};

export default MemberDetailPage;
